import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStages: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGES,
	},
	getRegulationsStagePreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_PREVIEW,
	},
	getRegulationsStagePopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_POPUP,
	},
	createRegulationsStage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].CREATE_REGULATIONS_STAGE,
	},
	getRegulationsStage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE,
	},
	patchRegulationsStage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PATCH_REGULATIONS_STAGE,
	},
	putRegulationsStage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PUT_REGULATIONS_STAGE,
	},
	deleteRegulationsStage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].DELETE_REGULATIONS_STAGE,
	},
}